export const publicNewsRoute = "/a29d045c-314d-45ad-95ba-08fa1b684f43";
